import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  constructor(private title: Title, private meta: Meta) {}

  updateTitle(title: string) {
    if (title) {
      this.title.setTitle(title);
    }
  }

  // Meta title
  updateMetaTitle(title: string) {
    this.meta.updateTag({ name: 'title', content: title });
  }
  addMetaTitle(title: string) {
    this.meta.addTag({ name: 'title', content: title }, true);
  }
  getMetaTitle():HTMLMetaElement{
    return this.meta.getTag("name='title'");
  }  
  removeMetaTitle(){
    let title: HTMLMetaElement = this.getMetaTitle();
    this.meta.removeTagElement(title);
  }

  // Meta og:title
  updateOgTitle(title: string) {
    this.meta.updateTag({ property: 'og:title', content: title });
  }
  addOgTitle(title: string) {
    this.meta.addTag({ property: 'og:title', content: title }, true);
  }
  getOgTitle():HTMLMetaElement{
    return this.meta.getTag("property='og:title'");
  }  
  removeOgTitle(){
    let title: HTMLMetaElement = this.getOgTitle();
    this.meta.removeTagElement(title);
  }
  
  // Meta url
  updateOgUrl(url: string) {
    this.meta.updateTag({ property: 'og:url', content: url })
  }

  updateUrl(url: string) {
    this.meta.updateTag({ name: 'url', content: url })
  }

  //Meta description
  updateDescription(description: string) {
    if (description) {
      this.meta.updateTag({ name: 'description', content: description });
    }
  }

  addDescription(desc: string) {
    this.meta.addTag({ name: 'description', content: desc }, true);
  }

  getDescription():HTMLMetaElement{
    return this.meta.getTag("name='description'");
  }

  removeDescription(){
    let description: HTMLMetaElement = this.getDescription();
    this.meta.removeTagElement(description);
  }

  // Meta og:description
  updateOgDescription(description: string) {
    if (description) {
      this.meta.updateTag({ property: 'og:description', content: description });
    }
  }
  
  addOgDescription(desc: string) {
    this.meta.addTag({ property: 'og:description', content: desc }, true);
  }
  
  getOgDescription():HTMLMetaElement{
    return this.meta.getTag("property='og:description'");
  }  
  
  removeOgDescription(){
    let description: HTMLMetaElement = this.getOgDescription();
    this.meta.removeTagElement(description);
  }
}

